import { T3 } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledContentWrapper, StyledNotificationIcon, StyledSeparatorNoResult } from './NoResults.styles';

export interface NoResultsProps { }

const NoResults: FC<NoResultsProps> = () => {
  const { t } = useTranslation('Notifications');

  return (
    <StyledContentWrapper>
      <StyledSeparatorNoResult />
      <StyledNotificationIcon />
      <T3 data-testid="NoNotificationTitle" align="center">{t('noNotification')}</T3>
    </StyledContentWrapper>
  );
};

export default NoResults;
